import axios from "axios";

let companyUserSvc = process.env.VUE_APP_COMPANY_API_URL;
let companyRoot = process.env.VUE_APP_COMPANY_USER_ROOT;

axios.defaults.headers.common["api_key"] =
	process.env.VUE_APP_CARD_USER_API_KEY;

const companyUserAxiosInstance = axios.create({
	baseURL: companyUserSvc,
});

export default {
	userService: {
		getUserData(url, token) {
			return  companyUserAxiosInstance.get(url, {
				headers: {
					Authorization: "Bearer " + btoa(token),
					"Content-Type": "application/x-www-form-urlencoded",
				},
			});
		},
		
		
		getUser(params, token) {
			return companyUserAxiosInstance.get(
				companyRoot +
				"/v1/cms/app_flows/search" +
				params,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		searchUsers( token) {
			return companyUserAxiosInstance.get(
				companyRoot +
				"/v1/cms/users",
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		addUser( formData, token) {
			return companyUserAxiosInstance.post(
				companyRoot + "/v1/cms/users" ,
				formData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		modifyUser( userId, params, token) {
			return companyUserAxiosInstance.put(
				companyRoot +
				"/v1/cms/users/" +
				userId,
				params,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		promoteUser( userId, params, token) {
			return companyUserAxiosInstance.put(
				companyRoot +
				"/v1/cms/users/promote/" +
				userId ,
				params,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		deleteUser( userId, token) {
			return companyUserAxiosInstance.delete(
				companyRoot +
				"/v1/cms/users/" +
				userId,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
	}
};
